import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { searchCategory } from "../../lib/api/search";
import { getCategory } from "../../lib/api/category";
import { mapProduct } from "../../state/modules/search/domains/results/products/mapAndInsertProducts/mapProduct";
import {
  getSearchApiDefaults,
  getStoreUrl,
  getCountry,
} from "../../state/modules/config/selectors";

import logger from "../../lib/logger";

const useFetchCategoryPreviewData = ({ cid, params }) => {
  const [categoryName, setCategoryName] = useState(null);
  const [categoryUrl, setCategoryUrl] = useState(null);
  const [products, setProducts] = useState(null);
  const [itemCount, setItemCount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const apiDefaults = useSelector(getSearchApiDefaults);
  const storeUrl = useSelector(getStoreUrl);
  const country = useSelector(getCountry);

  const apiQueryObject = {
    ...apiDefaults,
    ...params,
    cid,
    offset: 0,
  };
  const categoryCallParams = {
    query: { cid },
    country,
    language: apiQueryObject.lang,
  };
  const fetchData = () => {
    Promise.all([
      getCategory(categoryCallParams),
      searchCategory(apiQueryObject),
    ])
      .then(([category, search]) => {
        const newProducts = search.products.map((product) => {
          const url = `${storeUrl}/${product.url}`;

          return {
            ...mapProduct({ product }),
            url,
            tileId: product.id,
          };
        });

        setProducts(newProducts);
        setItemCount(search.itemCount);
        setCategoryName(search.categoryName);
        setCategoryUrl(category.categories.linkUrl);
      })
      .catch((error) => {
        setIsError(true);
        error.message = `useFetchCategoryPreviewData failed, and caught error: ${error.message}`;
        logger.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [cid]);

  return {
    products,
    categoryName,
    categoryUrl,
    itemCount,
    isLoading,
    isError,
  };
};

export default useFetchCategoryPreviewData;
